export default function CsSyllabus() {
  return (
    <h2>Cs Syllabus</h2>
  );
}
